import { timeZoneOptions, zoneLabel } from '@ly360/i18n';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from './Pickers.tsx';

/**
 * Time zone picker: optional "organisation default" entry, GCC + India + UTC first, then every IANA zone,
 * each labelled with its current offset.
 */
export function ZoneSelect({
  id,
  value,
  onChange,
  inheritLabel,
}: {
  id?: string;
  /** null = inherit the organisation default (only when inheritLabel is given). */
  value: string | null;
  onChange: (tz: string | null) => void;
  inheritLabel?: string;
}) {
  const { t } = useTranslation();
  const zones = useMemo(() => {
    const now = new Date();
    return timeZoneOptions().map((z) => ({
      z,
      label: `${z.replace(/_/g, ' ')} (${z === 'UTC' ? 'UTC' : zoneLabel(z, now)})`,
    }));
  }, []);
  return (
    <Select
      id={id}
      value={value ?? ''}
      onChange={(v) => onChange(v || null)}
      searchable
      placeholder={inheritLabel ?? t('settings.timezone')}
      data-testid="zone-select"
      options={[
        ...(inheritLabel ? [{ value: '', label: inheritLabel }] : []),
        ...zones.map((o) => ({ value: o.z, label: o.label })),
      ]}
    />
  );
}
